/**
 * Where the app opens (pages/Start.tsx): Início — or, in the desktop app, Conectar agente while no agent is
 * connected. A browser opens Início either way: there, the next step is a card that says to get the app
 * (components/GetTheApp.tsx, docs/refactor/51 N1), not a screen of keys and terminals.
 */
export const START = '/dashboard'

/** The download section of the site. */
export const DOWNLOAD_URL = 'https://vephus.ai/#download'

export function startPath(desktop: boolean, connected: boolean): string {
  if (connected || !desktop) return START
  return '/agents/connect?tab=desktop'
}
